import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, OnDestroy, Optional } from '@angular/core';
import { combineLatest, EMPTY, NEVER, Observable, Subscription, switchMap, timer } from 'rxjs';
import { catchError, distinctUntilChanged } from 'rxjs/operators';
import { MmuUserService } from '../auth/user-service/mmu-user.service';
import { MMU_KEEP_ALIVE_ENDPOINT, MMU_KEEP_ALIVE_INTERVAL } from './keep-alive-optional-config-tokens';


@Injectable({
  providedIn: 'root'
})
export class MmuKeepAliveService implements OnDestroy {
  readonly keepAlive$: Subscription;

  constructor(
    private httpClient: HttpClient,
    private userService: MmuUserService,
    @Optional() @Inject(MMU_KEEP_ALIVE_ENDPOINT) private readonly keepAliveEndpoint: string,
    @Optional() @Inject(MMU_KEEP_ALIVE_INTERVAL) private readonly keepAliveIntervalInMilliseconds: number
  ) {
    if (!this.keepAliveEndpoint) {
      this.keepAliveEndpoint = '/alive';
    }
    if (!this.keepAliveIntervalInMilliseconds) {
      this.keepAliveIntervalInMilliseconds = 30_000;
    }
    this.keepAlive$ = this.keepAlive().subscribe();
  }

  keepAlive(): Observable<never> | Observable<void> {
    return combineLatest([
      timer(0, this.keepAliveIntervalInMilliseconds),
      this.userService.authenticated$.pipe(distinctUntilChanged())
    ]).pipe(
      switchMap(([_unusedTimerCounter, authenticated]) => {
        if (!authenticated) {
          return NEVER;
        }
        return this.doRequest().pipe(
          catchError((err) => {
            console.error(`Error while calling ${this.keepAliveEndpoint}, ignoring and continue polling`, err);
            return EMPTY;
          })
        );
      })
    );
  }

  private doRequest(): Observable<void> {
    return this.httpClient.post<void>(
      this.keepAliveEndpoint,
      {},
      {
        headers: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'MIELE-no-intercept': 'true',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'MIELE-no-toasts': 'true'
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.keepAlive$.unsubscribe();
  }
}
